/**
 * Livacils Lazy Load
 * Blur-up progressive image loading
 */

(function () {
  'use strict';

  // Native lazy loading is already set via loading="lazy" on images.
  // This script handles blur-up effect for images with data-src attribute
  // and IntersectionObserver for older browsers.

  const supportsNativeLazy = 'loading' in HTMLImageElement.prototype;

  // ─── Blur-up lazy images ─────────────────────────────────────────
  const lazyImages = document.querySelectorAll('img[data-src]');

  if (lazyImages.length === 0) return;

  const loadImage = (img) => {
    const src = img.dataset.src;
    const srcset = img.dataset.srcset;

    if (!src) return;

    img.classList.add('lazy-loading');

    const tempImg = new Image();
    tempImg.onload = () => {
      img.src = src;
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.classList.remove('lazy-loading');
      img.classList.add('lazy-loaded');
    };
    tempImg.src = src;
  };

  if (supportsNativeLazy) {
    lazyImages.forEach(loadImage);
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadImage(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    lazyImages.forEach((img) => observer.observe(img));
  }

  // ─── Blur-up CSS ─────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    img.lazy-loading {
      filter: blur(8px);
      transition: filter 0.4s ease-out;
    }
    img.lazy-loaded {
      filter: blur(0);
    }
  `;
  document.head.appendChild(style);

})();
